module.exports = __webpack_public_path__ + "static/media/spotlightGreen.62a4512f.svg";